import React from 'react'

const BakeryMenu: React.FC = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      width="32"
      height="32"
      rx="6.64935"
      fill="url(#paint0_linear_4521_17271)"
      fillOpacity="0.1"
    />
    <path
      d="M13.234 18.845C13.1129 16.9386 12.084 15.5768 10.5407 14.5479C10.571 14.5176 10.6012 14.4571 10.6315 14.4269C11.1762 13.8519 11.7209 13.2769 12.2656 12.7322C12.3261 12.6717 12.4472 12.6414 12.538 12.6112C13.8089 12.5204 14.8681 13.0651 15.7457 13.9427C16.1391 14.3361 16.4719 14.7597 16.8351 15.1531C16.8956 14.6084 16.4719 13.398 16.018 12.702C15.5036 11.9757 14.8681 11.3705 14.1116 10.8863C14.1418 10.856 14.1418 10.8258 14.1721 10.8258C15.0194 10.2811 15.8667 9.70608 16.714 9.16138C16.8653 9.0706 17.0167 9.0706 17.1982 9.13112C18.1666 9.37321 18.8929 9.94818 19.5283 10.6442C19.8007 10.9165 20.0125 11.2192 20.2849 11.5218C20.3151 11.5823 20.3757 11.6126 20.4664 11.7336C20.3151 10.3718 19.831 9.25216 18.8626 8.37458C18.8626 8.34432 18.8626 8.31406 18.8626 8.31406C19.3468 8.22328 19.831 8.10223 20.3454 8.04171C20.9506 7.95092 21.5861 8.01145 22.1611 8.19302C23.2505 8.52589 23.8255 9.31269 24.007 10.4021C24.1886 11.4915 23.9768 12.5204 23.6439 13.5493C23.0387 15.2742 22.0703 16.8175 20.8901 18.2095C19.256 20.1765 17.3495 21.8106 15.0497 22.9606C14.0208 23.475 12.9314 23.8684 11.7512 23.9895C11.1157 24.0197 10.571 23.9895 10.0263 23.8381C8.87634 23.5355 8.11981 22.658 7.9685 21.4475C7.81719 20.2673 8.08955 19.1476 8.51321 18.0582C8.7553 17.4833 9.05791 16.9386 9.3 16.3636C9.36052 16.2425 9.42105 16.2123 9.57235 16.2425C10.571 16.3333 11.388 16.7872 12.0538 17.4833C12.4472 17.9069 12.8103 18.3911 13.234 18.845Z"
      fill="#052351"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4521_17271"
        x1="15.7922"
        y1="0"
        x2="15.7922"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0062FF" />
        <stop offset="1" stopColor="#004BC2" />
      </linearGradient>
    </defs>
  </svg>
)

export default BakeryMenu
